module.exports = __webpack_public_path__ + "static/media/play.dd2db142.svg";